import React, { useEffect } from "react";
import { useThree } from "@react-three/fiber";
import * as THREE from "three";

const FloorPlan3DRendererSettings: React.FC<{
  active: boolean;
  shadowsEnabled: boolean;
  shadowUpdateKey: string;
}> = ({ active, shadowsEnabled, shadowUpdateKey }) => {
  const { gl, invalidate } = useThree();
  const shadowMapsOn = active && shadowsEnabled;

  useEffect(() => {
    const previousToneMapping = gl.toneMapping;
    const previousToneMappingExposure = gl.toneMappingExposure;
    const previousShadowMapEnabled = gl.shadowMap.enabled;
    const previousShadowMapAutoUpdate = gl.shadowMap.autoUpdate;
    const previousShadowMapType = gl.shadowMap.type;

    gl.shadowMap.enabled = shadowMapsOn;
    // Demand-mode: update shadows manually so toggles/layout changes refresh
    // immediately. Always mark needsUpdate so turning shadows OFF also redraws.
    gl.shadowMap.autoUpdate = false;
    gl.shadowMap.needsUpdate = true;
    gl.shadowMap.type = THREE.PCFShadowMap;
    gl.toneMapping = active ? THREE.ACESFilmicToneMapping : THREE.NoToneMapping;
    gl.toneMappingExposure = active ? 1.08 : 1;
    invalidate();

    return () => {
      gl.toneMapping = previousToneMapping;
      gl.toneMappingExposure = previousToneMappingExposure;
      gl.shadowMap.enabled = previousShadowMapEnabled;
      gl.shadowMap.autoUpdate = previousShadowMapAutoUpdate;
      gl.shadowMap.type = previousShadowMapType;
      gl.shadowMap.needsUpdate = true;
      invalidate();
    };
  }, [active, gl, invalidate, shadowMapsOn]);

  useEffect(() => {
    gl.shadowMap.needsUpdate = true;
    invalidate();
  }, [gl, invalidate, shadowMapsOn, shadowUpdateKey]);

  return null;
};

export default FloorPlan3DRendererSettings;
